<template>
</template>
<script>
  export default {
    data() {
      let vm = this;
      return {
        element: null,
        resources: {
          zIndex: {
            name: 'zIndex',
            defaultValue: '',
            labelDesc: 'zIndex',
            callback: function () {
              vm.resources.zIndex.defaultValue = this.value;
              vm.element.internal_config.zIndex = this.value;


            },
          },
          maxWidth: {
            name: 'maxWidth',
            defaultValue: '500',
            min: '200',
            max: '768',
            labelDesc: 'max-width-tablet',
            callback: function () {
              vm.resources.maxWidth.defaultValue = this.value;
              vm.element.internal_config.maxWidth = this.value + 'px';


            },
          },

          height: {
            name: 'height',
            defaultValue: '300',
            min: '1',
            max: '10000',
            labelDesc: 'height',
            callback: function () {
              vm.resources.height.defaultValue = this.value;
              vm.element.internal_config.height = this.value + 'px';


            },
          },

          heightContainer: {
            name: 'heightContainer',
            defaultValue: '300',
            min: '1',
            max: '10000',
            labelDesc: 'heightContainer',
            callback: function () {
              vm.resources.heightContainer.defaultValue = this.value;
              vm.element.internal_config.heightContainer = this.value + 'px';


            },
          },

          backgroundColor: {
            name: 'backgroundColor',
            defaultValue: '#ffffff',
            gradient: true,
            labelDesc: 'bg-color-header',
            callback: function () {
              vm.resources.backgroundColor.defaultValue = this.colorValue;
              vm.element.internal_config.backgroundColor = this.colorValue;


            },
          },

          border: {
            name: 'border',
            defaultValue: '1px solid black',
            min: '0',
            max: '50',
            labelDesc: 'border',
            callback: function () {
              let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

              vm.resources.border.defaultValue = value;
              vm.element.internal_config.border = value;


            },
          },

          borderRadius: {
            name: 'borderRadius',
            defaultValue: '0 0 0 0',
            min: '0',
            max: '360',
            labelDesc: 'borderRadius',
            callback: function () {

              let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

              vm.resources.borderRadius.defaultValue = value;
              vm.element.internal_config.borderRadius = value;
            },
          },

          backgroundColorContainer: {
            name: 'backgroundColorContainer',
            defaultValue: '#ffffff',
            gradient: true,
            labelDesc: 'bg-color-container',
            callback: function () {
              vm.resources.backgroundColorContainer.defaultValue = this.colorValue;
              vm.element.internal_config.backgroundColorContainer = this.colorValue;
            },
          },

          borderContainer: {
            name: 'borderContainer',
            defaultValue: '1px solid black',
            min: '0',
            max: '50',
            labelDesc: 'border',
            callback: function () {
              let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

              vm.resources.borderContainer.defaultValue = value;
              vm.element.internal_config.borderContainer = value;
            },
          },

          borderRadiusContainer: {
            name: 'borderRadiusContainer',
            defaultValue: '0 0 0 0',
            min: '0',
            max: '360',
            labelDesc: 'borderRadiusContainer',
            callback: function () {

              let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

              vm.resources.borderRadiusContainer.defaultValue = value;
              vm.element.internal_config.borderRadiusContainer = value;
            },
          },

          icon: {
            name: 'icon',
            defaultIcon: '',
            defaultPosition: 'left',
            labelDesc: 'icon',
            callback: function () {

              vm.resources.icon.defaultIcon = this.iconSelected;
              vm.resources.icon.defaultPosition = this.position;

              vm.element.internal_config.icon = this.iconSelected;
              vm.element.internal_config.iconPosition = this.position;

            },
          },

          text: {
            name: 'text',
            defaultValue: '',
            labelDesc: 'accordion-headline',
            canRemove: false,
            callback: function () {
              vm.resources.text.defaultValue = this.value;
              vm.element.internal_config.text = this.value;

              vm.element.internal_config.backgroundColor = vm.resources.backgroundColor.defaultValue;
            },
          },

          textStyle: {
            name: 'textStyle',
            defaultFamily: '',
            defaultSize: '',
            showSizeMobile: true,
            shitOptions: true,
            defaultSizeMobile: '',
            defaultColor: '',
            defaultAlign: '',
            defaultWeight: '',
            defaultStroke: '',
            defaultStyle: '',
            labelDesc: 'textStyle',
            callback: function () {

              vm.resources.textStyle.defaultFamily = this.family;
              vm.element.internal_config.textStyle.family = this.family;

              vm.resources.textStyle.defaultSize = this.size + 'px';
              vm.element.internal_config.textStyle.size = this.size + 'px';

              vm.resources.textStyle.defaultSizeMobile = this.sizeMobile + 'px';
              vm.element.internal_config.textStyle.sizeMobile = this.sizeMobile + 'px';

              vm.resources.textStyle.defaultColor = this.color;
              vm.element.internal_config.textStyle.color = this.color;

              vm.resources.textStyle.defaultAlign = this.align;
              vm.element.internal_config.textStyle.align = this.align;

              vm.resources.textStyle.defaultWeight = this.weight;
              vm.element.internal_config.textStyle.weight = this.weight;

              vm.resources.textStyle.defaultStyle = this.style;
              vm.element.internal_config.textStyle.style = this.style;

              vm.resources.textStyle.defaultStroke = this.stroke;
              vm.element.internal_config.textStyle.stroke = this.stroke;
            },
          },

          padding: {
            name: 'padding',
            defaultLeft: '15',
            defaultTop: '15',
            defaultRight: '15',
            defaultBottom: '15',
            min: '0',
            max: '100',
            labelDesc: 'padding',
            callback: function () {
              vm.resources.padding.defaultLeft = this.l;
              vm.element.internal_config.paddingLeft = this.l + 'px';

              vm.resources.padding.defaultTop = this.t;
              vm.element.internal_config.paddingTop = this.t + 'px';

              vm.resources.padding.defaultRight = this.r;
              vm.element.internal_config.paddingRight = this.r + 'px';

              vm.resources.padding.defaultBottom = this.b;
              vm.element.internal_config.paddingBottom = this.b + 'px';
            },
          },
        }
      }
    },
    methods: {
      setValuesData(data) {
        this.element = data;

        this.resources.text.defaultValue = data.internal_config.text;

        this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);
        this.resources.height.defaultValue = parseInt(data.internal_config.height);
        this.resources.heightContainer.defaultValue = parseInt(data.internal_config.heightContainer);

        this.resources.border.defaultValue = data.internal_config.border;
        this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
        this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;

        this.resources.textStyle.defaultFamily = data.internal_config.textStyle.family;
        this.resources.textStyle.defaultSize = data.internal_config.textStyle.size;
        this.resources.textStyle.defaultSizeMobile = data.internal_config.textStyle.sizeMobile;
        this.resources.textStyle.defaultColor = data.internal_config.textStyle.color;
        this.resources.textStyle.defaultAlign = data.internal_config.textStyle.align;
        this.resources.textStyle.defaultWeight = data.internal_config.textStyle.weight;
        this.resources.textStyle.defaultStyle = data.internal_config.textStyle.style;
        this.resources.textStyle.defaultStroke = data.internal_config.textStyle.stroke;

        this.resources.borderContainer.defaultValue = data.internal_config.borderContainer;
        this.resources.borderRadiusContainer.defaultValue = data.internal_config.borderRadiusContainer;
        this.resources.backgroundColorContainer.defaultValue = data.internal_config.backgroundColorContainer;

        this.resources.icon.defaultIcon = data.internal_config.icon;
        this.resources.icon.defaultPosition = data.internal_config.iconPosition;

        this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
        this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
        this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
        this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
      },
      getValuesData() {
        return this.resources;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/AccordionElement/Accordion/Resources.vue